import MyUploads from '../components/MyUploads';

const Component = () => <MyUploads />;

const path = '#uploads';
import { MultipleUploadIcon as label } from '@/icons';

const description = 'Envoie des fichiers';

const Page = { Component, path, label, description };
export default Page;
